export default __webpack_public_path__ + "static/media/8920.6bf5f954.svg";